/**
 *
 */
export enum RecordAction {
    archive = "archive",
    copy = "copy",
    edit = "edit",
    unarchive = "unarchive",
    delete = "delete"
}